var fixHeader = function(){

    // header
    var header = document.getElementById("header");

    // find out height of header element
    var headerHeight = header.clientHeight;

    // set --header-height custom property
    document.documentElement.style.setProperty("--header-height", headerHeight + "px");

    // only fix header on windows >= 768px
    var windowWidth = document.body.clientWidth;

    if(windowWidth > 767){
        // get scroll position
        let scroll = window.scrollY;
        if (scroll > 50) {
            header.classList.add("scrolling");
        } else {
            header.classList.remove("scrolling");
        } 
    }

};

// Run on scroll/load/resize
window.addEventListener("scroll", fixHeader, false);
window.addEventListener("load", fixHeader, false);
window.addEventListener("resize", fixHeader, false);